export default {
      id: "ic_director-usage",
      viewBox: "0 0 22 28",
      url: "/" + "images/icons.3.109.2.svg#ic_director-usage",
      toString: function () {
        return this.url;
      }
    }